/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable @typescript-eslint/no-misused-promises */

'use client'

import React, { useState, useEffect } from 'react'
import Image from 'next/image'
import { WidgetType } from '@enums/WidgetType'
import assetLoader from '@utils/internalImageLoader'
import { SEGMENT } from '@components/MainWidget/common/widgetSegments'
import { pageEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import Cookies from 'js-cookie'
import { WebViewActions, callWebviewHandlerV2 } from '@utils/webview'
import { deepLinkConfig } from '@configs/deeplink.config'
import { onDownloadApp } from '@components/MainWidget/common/helper'
import {
  getDaysUntilPolicyExpiry,
  getVehicleVariantImage,
  redirectToAutoPayment,
} from '@components/WhatsappChallanFlow/helper'
import { segmentEventCommonPropFunc } from '@utils/segmentProperties'
import { waitForAnalyticsLoad } from '@components/utils/analyticsViewPage'
import { INPUT_ICON, INPUT_ICON_LOGO } from '@components/MainWidget/FastagWidget/constants'
import { getProductName } from '@components/MainWidget/ChallanWidgetLanding/helper'
import {
  whatsappLoadingScreens,
  DEFAULT_CAR_MODAL,
  UNAPID_CHALLANS,
  APP_CHALLANS,
  UNABLE_TO_PROCESS_PNG,
  RENEWAL_BANNER_IMAGE_PNG,
  UNPAID_CHALLAN_BANNER_PNG,
  CHECK_PRICE_URL,
} from './constants'
import WhatsappChallanLoadingScreen from './whatsappChallanLoadingScreen'
import styles from './whatsappChallan.module.scss'

const vehicleTypeMap = {
  PRIVATE_CAR: 'Car',
  TWO_WHEELER: 'Bike',
}

const vehicleType = vehicleData => vehicleTypeMap?.[vehicleData?.vehicle_type_v2] || 'N/A'

const WhatsappChallanFlow = ({ regNum, phoneNumber, vehicleData, vehicleImage, segmentEventCommonProperties }) => {
  const [loadingComplete, setLoadingComplete] = useState(false)

  const handleLoadingComplete = () => {
    setLoadingComplete(true)
  }

  const vehicleVaraintImage = getVehicleVariantImage(vehicleImage)
  useEffect(() => {
    if (Cookies.get('webview')) {
      callWebviewHandlerV2({
        url: deepLinkConfig[WidgetType.CHALLAN_WIDGET_LANDING],
        action: WebViewActions.OPEN_DEEPLINK,
      })
    }
  }, [])

  useEffect(() => {
    ;(async () => {
      const properties = await segmentEventCommonPropFunc(segmentEventCommonProperties)

      waitForAnalyticsLoad().then(() => {
        pageEvent(SEGMENT.VIEW_PAGE, {
          ...properties,
          product: getProductName(),
          phone: phoneNumber || '',
          registration_number: regNum || '',
          vehicle_type: vehicleType(vehicleData) || 'N/A',
          mm_name: vehicleData?.model_name || '',
          previous_policy_expiry_date: vehicleData?.previous_policy_expiry_detail || '',
          expiry_date: vehicleData?.previous_policy_expiry_detail || '',
          vas_amount: null,
        }).catch(err => {
          console.log('Wait for analytics load error', err)
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
      })
    })()
  }, [])

  return (
    <div className={styles.seeWhatsappFlow}>
      {!loadingComplete ? (
        <WhatsappChallanLoadingScreen
          screens={whatsappLoadingScreens}
          duration={1000}
          onComplete={handleLoadingComplete}
        />
      ) : (
        <div className={styles.whatsappChallanContainer}>
          <div className={styles.headerVehicleInfo}>
            <div className={styles.vehicleDetails}>
              <p className={styles.vehicleName}>
                {vehicleData?.db_make_name && vehicleData?.db_model_name
                  ? `${vehicleData.db_make_name} ${vehicleData.db_model_name}`
                  : DEFAULT_CAR_MODAL}
              </p>
              <div className={styles.InputBoxContainer}>
                <Image
                  width={24}
                  height={28}
                  src={`${assetLoader()}${INPUT_ICON}`}
                  className={styles.inputIcon}
                  alt={INPUT_ICON_LOGO}
                />
                <input
                  type="text"
                  id="challanWidgetInput"
                  placeholder={regNum}
                  className={styles.inputField}
                  autoComplete="off"
                  value={regNum}
                  readOnly
                  disabled
                />
              </div>
            </div>
            <div className={styles.vehicleImage}>
              <Image width={126} height={72} src={vehicleVaraintImage} alt="challan vehicle image" />
            </div>
          </div>
          <div className={styles.pageDivider} />
          <div className={styles.connectBannerWithImage}>
            <div className={styles.insuranceExpBanner}>
              <Image width={40} height={40} src={UNABLE_TO_PROCESS_PNG} alt="Unable to process" />
              <p className={styles.expiryText}>
                Your insurance expires in{' '}
                <span className={styles.expiryHighlight}>{`${getDaysUntilPolicyExpiry(vehicleData)} days`}</span>
              </p>
              <p className={styles.expirySubText}>Renew now to stay protected</p>
              <button
                onClick={() => redirectToAutoPayment(CHECK_PRICE_URL, regNum, phoneNumber)}
                className={styles.primaryButtonForExpBanner}>
                Check your special price
              </button>
            </div>
            <div className={styles.renewalIconContainer}>
              <Image
                width={100}
                height={76}
                src={RENEWAL_BANNER_IMAGE_PNG}
                alt="renewal banner"
                className={styles.renewalBannerImage}
              />
            </div>
          </div>

          <div className={styles.unpaidChallanContainer}>
            <p className={styles.unpaidChallanHeading}>{UNAPID_CHALLANS}</p>
            <Image
              width={100}
              height={100}
              src={UNPAID_CHALLAN_BANNER_PNG}
              alt="Unpaid challan banner"
              className={styles.unpaidBannerImage}
            />

            <button
              className={styles.buttonDownload}
              onClick={() =>
                onDownloadApp({
                  regNo: regNum,
                  widgetType: WidgetType.CHALLAN_WIDGET_LANDING,
                  phone: phoneNumber,
                  vehicleData: vehicleData,
                })
              }>
              {APP_CHALLANS}
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default WhatsappChallanFlow
